import { Link } from 'react-router-dom';

/**
 * Política de Privacidad — RGPD (UE 2016/679) + LOPDGDD (LO 3/2018)
 * Adaptada para TUVISA Calendar (app no comercial, proyecto personal)
 */
const PoliticaPrivacidad = () => {
    const sectionStyle = {
        marginBottom: '2rem'
    };

    const headingStyle = {
        fontSize: '1.3rem',
        fontWeight: 700,
        color: '#f1f5f9',
        marginBottom: '0.75rem',
        borderBottom: '1px solid rgba(56, 189, 248, 0.15)',
        paddingBottom: '0.5rem'
    };

    const subHeadingStyle = {
        fontSize: '1.05rem',
        fontWeight: 600,
        color: '#e2e8f0',
        marginBottom: '0.5rem',
        marginTop: '1rem'
    };

    const textStyle = {
        color: '#94a3b8',
        lineHeight: 1.7,
        fontSize: '0.95rem',
        marginBottom: '0.75rem'
    };

    const listStyle = {
        color: '#94a3b8',
        lineHeight: 1.8,
        paddingLeft: '1.5rem',
        fontSize: '0.95rem',
        marginBottom: '0.75rem'
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '1rem',
        fontSize: '0.9rem'
    };

    const thStyle = {
        textAlign: 'left',
        padding: '0.6rem 0.75rem',
        borderBottom: '1px solid rgba(56, 189, 248, 0.2)',
        color: '#e2e8f0',
        fontWeight: 600,
        background: 'rgba(56, 189, 248, 0.05)'
    };

    const tdStyle = {
        padding: '0.6rem 0.75rem',
        borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
        color: '#94a3b8'
    };

    return (
        <div>
            <h1 style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#f8fafc',
                marginBottom: '0.5rem'
            }}>
                Política de Privacidad
            </h1>
            <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '2rem' }}>
                Última actualización: 11 de marzo de 2026
            </p>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>1. Responsable del Tratamiento</h2>
                <table style={tableStyle}>
                    <tbody>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1', width: '35%' }}>Responsable</td>
                            <td style={tdStyle}>Administrador de calendario.xerp.es</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Email de contacto</td>
                            <td style={tdStyle}>info@xerp.es</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Sitio web</td>
                            <td style={tdStyle}>https://calendario.xerp.es</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>2. Finalidad del Tratamiento</h2>
                <p style={textStyle}>
                    Los datos personales recogidos a través de TUVISA Calendar se tratan con las
                    siguientes finalidades:
                </p>
                <ul style={listStyle}>
                    <li><strong>Gestión de acceso:</strong> Identificar y autenticar a los usuarios de la aplicación.</li>
                    <li><strong>Calendario laboral:</strong> Visualización de turnos, libranzas, vacaciones y festivos asociados a cada conductor.</li>
                    <li><strong>Intercambio de días (Mercadillo):</strong> Facilitar el intercambio de jornadas laborales entre compañeros.</li>
                    <li><strong>Comunicaciones internas:</strong> Envío de avisos y notificaciones relevantes para la actividad laboral.</li>
                    <li><strong>Notificaciones push:</strong> Alertas en tiempo real sobre cambios, recordatorios y avisos.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>3. Datos Personales Recogidos</h2>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Dato</th>
                            <th style={thStyle}>Origen</th>
                            <th style={thStyle}>Finalidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={tdStyle}>Nombre completo</td>
                            <td style={tdStyle}>Google OAuth</td>
                            <td style={tdStyle}>Identificación del usuario</td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>Dirección de email</td>
                            <td style={tdStyle}>Google OAuth</td>
                            <td style={tdStyle}>Login y comunicaciones</td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>Foto de perfil</td>
                            <td style={tdStyle}>Google OAuth</td>
                            <td style={tdStyle}>Interfaz de usuario</td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>Token de notificaciones</td>
                            <td style={tdStyle}>Firebase / Navegador</td>
                            <td style={tdStyle}>Envío de alertas push</td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>Datos laborales (turno, conductor asociado)</td>
                            <td style={tdStyle}>Configuración administrativa</td>
                            <td style={tdStyle}>Cálculo del calendario</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>4. Base Legal del Tratamiento</h2>
                <ul style={listStyle}>
                    <li><strong>Consentimiento (Art. 6.1.a RGPD):</strong> Al iniciar sesión con Google OAuth, el usuario consiente expresamente el tratamiento de sus datos.</li>
                    <li><strong>Interés legítimo (Art. 6.1.f RGPD):</strong> Facilitar la gestión del calendario laboral interno de TUVISA es de interés legítimo tanto para la empresa como para los conductores.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>5. Destinatarios de los Datos</h2>
                <p style={textStyle}>Tus datos personales pueden ser comunicados a los siguientes terceros:</p>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Destinatario</th>
                            <th style={thStyle}>Finalidad</th>
                            <th style={thStyle}>Garantías</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={tdStyle}>Google LLC</td>
                            <td style={tdStyle}>Autenticación OAuth</td>
                            <td style={tdStyle}>Adherido al Data Privacy Framework (UE-EEUU)</td>
                        </tr>
                        <tr>
                            <td style={tdStyle}>Firebase (Google)</td>
                            <td style={tdStyle}>Notificaciones push</td>
                            <td style={tdStyle}>Adherido al Data Privacy Framework (UE-EEUU)</td>
                        </tr>
                    </tbody>
                </table>
                <p style={textStyle}>
                    No se venden, ceden ni comparten datos personales con terceros con fines
                    comerciales o publicitarios.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>6. Plazo de Conservación</h2>
                <p style={textStyle}>
                    Los datos personales se conservarán mientras la cuenta de usuario esté activa.
                    Si un usuario solicita la eliminación de su cuenta, sus datos serán suprimidos
                    en un plazo máximo de <strong>30 días</strong>, salvo obligación legal de conservación.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>7. Derechos del Interesado</h2>
                <p style={textStyle}>
                    De acuerdo con el RGPD y la LOPDGDD, tienes derecho a:
                </p>
                <ul style={listStyle}>
                    <li><strong>Acceso:</strong> Conocer qué datos personales tuyos tratamos.</li>
                    <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos.</li>
                    <li><strong>Supresión ("Derecho al Olvido"):</strong> Solicitar la eliminación de tus datos.</li>
                    <li><strong>Limitación:</strong> Solicitar que se restrinja el tratamiento de tus datos.</li>
                    <li><strong>Portabilidad:</strong> Recibir tus datos en un formato estructurado y legible por máquina.</li>
                    <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos en determinadas circunstancias.</li>
                </ul>
                <p style={textStyle}>
                    Para ejercer cualquiera de estos derechos, envía un email a{' '}
                    <a href="mailto:info@xerp.es" style={{ color: '#38bdf8' }}>info@xerp.es</a>{' '}
                    indicando tu nombre y el derecho que deseas ejercer.
                </p>
                <p style={textStyle}>
                    También tienes derecho a presentar una reclamación ante la{' '}
                    <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" style={{ color: '#38bdf8' }}>
                        Agencia Española de Protección de Datos (AEPD)
                    </a>{' '}
                    si consideras que tus derechos no han sido debidamente atendidos.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>8. Seguridad de los Datos</h2>
                <p style={textStyle}>
                    Aplicamos medidas técnicas y organizativas para proteger tus datos personales,
                    incluyendo:
                </p>
                <ul style={listStyle}>
                    <li>Comunicaciones cifradas con HTTPS (SSL/TLS).</li>
                    <li>Cookies de autenticación HttpOnly no accesibles desde JavaScript.</li>
                    <li>Contraseñas cifradas con algoritmos de hash seguros (bcrypt).</li>
                    <li>Acceso restringido a la base de datos mediante red privada (Tailscale).</li>
                    <li>Tokens JWT con expiración de 8 horas.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>9. Modificaciones</h2>
                <p style={textStyle}>
                    Nos reservamos el derecho de actualizar esta política para reflejar cambios en
                    nuestras prácticas o en la legislación aplicable. Cualquier modificación será
                    publicada en esta misma página con la fecha de actualización correspondiente.
                </p>
            </section>

            <div style={{
                marginTop: '2rem',
                padding: '1rem',
                borderRadius: '0.75rem',
                background: 'rgba(56, 189, 248, 0.05)',
                border: '1px solid rgba(56, 189, 248, 0.1)',
                textAlign: 'center'
            }}>
                <p style={{ color: '#64748b', fontSize: '0.85rem', margin: 0 }}>
                    ¿Tienes dudas? Escríbenos a{' '}
                    <a href="mailto:info@xerp.es" style={{ color: '#38bdf8' }}>info@xerp.es</a>
                </p>
            </div>
        </div>
    );
};

export default PoliticaPrivacidad;
